<script setup lang="ts">
import { CtCallout } from '@camelot/components'
import DateTimePicker from '~/components/input/date-time/DateTimePicker.vue'
import { useDateTimeStore } from '~/stores/datetime'

const { isWebview = false } = defineProps<{ isWebview?: boolean }>()

const dateTimeStore = useDateTimeStore()
</script>

<template>
  <article>
    <h3 v-if="!isWebview" class="text-black-100">
      {{ translate('headline_date_time') }}
    </h3>
    <h4 v-if="isWebview" class="text-black-100 mt-32">
      {{ translate('headline_date_time') }}
    </h4>

    <form class="flex flex-col gap-[10px] mt-[22px] lg:flex-row">
      <DateTimePicker
        v-model="dateTimeStore.startDate"
        :min-date="dateTimeStore.minStartingDate"
        :max-date="dateTimeStore.maxStartingDate"
        date-label-translation-key="field_label_start_date"
        :error-message="dateTimeStore.errorStartingDate"
        :has-global-error="dateTimeStore.errorBookingPeriod !== undefined"
      />
      <DateTimePicker
        v-model="dateTimeStore.endDate"
        :min-date="dateTimeStore.minEndingDate"
        :max-date="dateTimeStore.maxEndingDate"
        date-label-translation-key="field_label_end_date"
        :error-message="dateTimeStore.errorEndingDate"
        :has-global-error="dateTimeStore.errorBookingPeriod !== undefined"
      />
    </form>
    <CtCallout v-if="dateTimeStore.errorBookingPeriod" variant="error">
      {{ dateTimeStore.errorBookingPeriod }}
    </CtCallout>
  </article>
</template>
